import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { proposedRuleHistoryAPI } from '../../utilities/api';
import { ProposedRuleHistory } from '../../utilities/interfaces/ProposedRuleHistory';

// represents the shape of the slice in state
interface proposedRuleHistoryState {
  proposedRuleHistory: ProposedRuleHistory[];
}

const initialState: proposedRuleHistoryState = {
  proposedRuleHistory: [],
};

const proposedRuleHistorySlice = createSlice({
  name: 'stateProposedRuleHistory',
  initialState,
  reducers: {
    // add new Agency item
    addProposedRuleItem(state, action: PayloadAction<ProposedRuleHistory>) {
      // its okay to do this because immer makes it immutable
      state.proposedRuleHistory.push(action.payload);
    },
  },
  extraReducers(builder) {
    builder.addCase(getProposedRuleHistoryByDraftId.pending, (state, action: any) => {
      state.proposedRuleHistory = [];
    });
    builder.addCase(getProposedRuleHistoryByDraftId.fulfilled, (state, action: any) => {
      state.proposedRuleHistory = action.payload;
    });
    builder.addCase(getAllProposedRuleHistory.fulfilled, (state, action: any) => {
      state.proposedRuleHistory = action.payload;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getProposedRuleHistoryByDraftId = createAsyncThunk(
  'stateProposedRuleHistory/getProposedRuleHistoryById',
  async (id: number) => {
    const response = await proposedRuleHistoryAPI.getProposedRuleHistoryByDraftId(id);
    return response;
  }
);
export const getAllProposedRuleHistory = createAsyncThunk(
  'stateProposedRuleHistory/getAllProposedRuleHistory',
  async () => {
    const response = await proposedRuleHistoryAPI.getAllProposedRuleHistory();
    return response;
  }
);

export const { addProposedRuleItem } = proposedRuleHistorySlice.actions;
export default proposedRuleHistorySlice.reducer;
